import axiosInstance from "../instance/axiosInstance";

class RequestsApi {
  static async getRequestsList(page, typeId) {
    let url = `/requests/list?page=${page}`;
    if (typeId === 1) url += `&type=${1}`;
    else url += `&type=${2}`;
    try {
      const response = await axiosInstance.get(url);
      if (response) return response.data;
    } catch (error) {
      return error;
    }
  }

  static async acceptRejectRequest(formData) {
    try {
      const response = await axiosInstance.post(`/requests/decision`, formData);
      if (response) return response.data;
    } catch (error) {
      return error;
    }
  }

  static async createRequest(formData) {
    try {
      const response = await axiosInstance.post(`/requests/save`, formData);
      if (response) return response.data;
    } catch (error) {
      return error;
    }
  }
  static async removeRequest(formData) {
    try {
      const response = await axiosInstance.post(
        `/remove-accessgranted-user`,
        formData
      );
      if (response) return response.data;
    } catch (error) {
      return error;
    }
  }
}

export default RequestsApi;
